import { useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Stack,
  Typography,
  Card,
  CardContent,
  Checkbox
} from "@mui/material";

import ScrollToTop from "../../nav/ScrollToTop";
import ActionButton from "../../account/ActionButton";
import SupportLinksCarousel from "./SupportLinksCarousel";

/**
 * Settlement help
 * @param {*} param0
 * @returns
 */
function SettlementHelp({ handleNext, handleBack }) {

  const [ affordabilityConsent, setAffordabilityConsent ] = useState(false);

  return (
    <>
      <ScrollToTop/>
      <Box>
        {/* Card with heading and text */}
        <Typography 
          variant='h6'
          sx={{ fontWeight: "bold", pb: 3 }}
        >
          Before you confirm, we're here to help you
        </Typography>
        <Card>
          <CardContent>
            <Typography sx={{ pb: 2 }}>
              We believe you've answered some questions that signal you
              might need some assistance. We'll never ask you to repay more
              than you can afford - first and foremost, we're simply here to
              support you with this debt, and the improvement of your
              financial health.
            </Typography>
            <Typography sx={{ pb: 2 }}>
              If you feel that you're struggling with your finances, speaking with 
              someone impartial could provide you with options to help you address 
              your current balance, learn more about budgeting, understand your credit 
              file, and more - all of which are things you maybe weren’t already aware of.
            </Typography>
            <Typography>
              It can be tough to talk about money, we understand that - so,
              for independent, free advice - you may want to contact the
              following organisations:
            </Typography>
          </CardContent>
        </Card>
      </Box>
      <SupportLinksCarousel/>
      <Box sx={{ pt: 5 }}>
        {/* Card with heading and text */}
        <Typography 
          variant='h6'
          sx={{ fontWeight: "bold", pb: 3 }}
        >
          Ready to set up your settlement plan?
        </Typography>
        <Card>
          <CardContent>
            {/* Affordability confirmation */}
            <Box id='affordability-declaration' sx={{ display: "flex", flexDirection: "row" }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Checkbox
                  id='affordability-declaration-checkbox'
                  checked={affordabilityConsent}
                  onChange={() => {
                    setAffordabilityConsent(!affordabilityConsent);
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Box>
              <Box padding={0.5}>
                <Typography
                  id='affordability-declaration-statement'
                  component='h2'
                  variant='p'
                  sx={{ display: "inline-block", mt: 0.5, fontSize: 16 }}
                >
                  I can confirm that I have considered my need for additional support 
                  and I am happy to make a payment towards my account.
                </Typography>
              </Box>
            </Box>
            {/* End of affordability confirmation */}
          </CardContent>
        </Card>

        {/* Call to action */}
        <Stack
          sx={{
            mt: 3,
            textAlign: { xs: "center", sm: "left" },
          }}
          direction={{
            xs: "column",
            sm: "row",
          }}        
        >
          {/* Back button */}
          <Box>
            <ActionButton
              id='back-btn'
              borderColor='primary.dark'
              buttonColor='transparent'
              buttonTextColor='primary.dark'
              buttonTitle='Back'
              variant='outlined'
              hoverColor='primary.dark'
              hoverBorderColor={"primary.dark"}
              hoverTextColor='secondary.contrastText'
              onClick={handleBack}
            />
          </Box>
          {/* End of back button */}

          {/* Continue button */}
          <Box>
            <ActionButton
              variant='contained'
              buttonColor='secondary.main'
              buttonTextColor='primary.contrastText'
              borderColor='transparent'
              hoverColor='primary.contrastText'
              hoverBorderColor='secondary.main'
              hoverTextColor='secondary.main'
              buttonTitle='Continue'
              onClick={handleNext}
              disabled={!affordabilityConsent}
            />
          </Box>
          {/* End of continue button */}
        </Stack>
        {/* End of call to action */}

      </Box>
    </>
  );
};

SettlementHelp.propTypes = {
  handleNext: PropTypes.func,
  handleBack: PropTypes.func,
};

export default SettlementHelp;
